export const progressBarPreset = {
  progressbar: {
    root: {
      background: 'var(--neutral--10)',
    },
    css: () => `
      .p-progressbar.upload-progress.uploading .p-progressbar-value {
        background-color: var(--brand--60);
      }

      .p-progressbar.upload-progress.completed .p-progressbar-value {
        background-color: #22C55E;
      }

      .p-progressbar.upload-progress.error .p-progressbar-value {
        background-color: #F43F5E;
      }
    `,
  },
};
